<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="cont"></a><a id="page_vii">Contents</a></h2><a id="page_vii">
</a><p class="cont-fm"><a id="page_vii"></a><span class="nounder" href="#/xhtml/ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="cont-fm"><a class="nounder" href="#/xhtml/foreword">Foreword, by Maj. Gen. Donald J. Strait, USAF (Ret.)</a></p>
<p class="cont-fmb"><a class="nounder" href="#/xhtml/stories">Telling Stories, by Lee Lauderback</a></p>
<p class="cont-fm"><a class="nounder" href="#/xhtml/introduction">Introduction:</a></p>
<p class="cont-fm"><a class="nounder" href="#/xhtml/introduction">Creation of a Thoroughbred</a></p>
<p class="cont"><a class="nounder" href="#/xhtml/ch01">1. Have Guns, Will Travel: Early Mustang Combat Memories</a></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch02" title="Link target outside of Sample">2. Killer Bs: P-51B/C Mustangs over Europe</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample">3. Prelude to Overlord</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample">4. Aloft over the Mediterranean</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample">5. Deeper into Germany</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample">6. A Christmas Story</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample">7. New Year’s Resolution</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch08" title="Link target outside of Sample">8. Double-Nickel Killers: Late-War Aerial Combat with the 55th Fighter Group</span></p>
<p class="cont"><span class="nounder" href="#/xhtml/ch09" title="Link target outside of Sample">9. Yak Attack</span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch10" title="Link target outside of Sample">10. Wonder Weapon Assassins: Rocket and Jet Killers of the Eto</span></p>
<p class="cont1"><span class="nounder" href="#/xhtml/ch11" title="Link target outside of Sample">11. Courage, Combat, and Legacies</span></p>
<p class="cont1b"><span class="nounder" href="#/xhtml/ch12" title="Link target outside of Sample">12. Mustangs vs. Japan</span></p>
<p class="cont-bm"><span class="nounder" href="#/xhtml/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="cont-bm"><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample">Index</span><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cont.vue?5e456a9d